import ProductServiceV2 from "@/services/productServiceV2";
import ProductVerifiedService from "@/services/productVerifiedService";

export const ProductStore = {
    namespaced: true,
    state: {
        tabs: {
            products: {
                tableData: [],
                totalRecords: 0,
                rowsPerPage: 20,
                currentPage: 1,
                sortField: "created_at",
                sortOrder: "-1",
                first: 0,
            },
            search: {
                tableData: [],
                totalRecords: 0,
                rowsPerPage: 20,
                currentPage: 1,
                sortField: "created_at",
                sortOrder: "-1",
                first: 0,
            },
            cleaned: {
                tableData: [],
                totalRecords: 0,
                rowsPerPage: 20,
                currentPage: 1,
                sortField: "created_at",
                sortOrder: "-1",
                first: 0,
            },
        },

        currentTab: "products",
        searchText: "",
        isLoading: false,

        // active | deleted | archived | moved
        productsView: "active",


        // active | deleted | archived
        cleanedView: "active",
    },

    mutations: {
        SET_TABLE_DATA(state, { tab, data }) {
            state.tabs[tab].tableData = data.data;
            state.tabs[tab].totalRecords = data.count;
        },

        UPDATE_CURRENT_PAGE(state, { tab, page }) {
            state.tabs[tab].currentPage = page;
        },

        UPDATE_ROWS_PER_PAGE(state, { tab, rows }) {
            state.tabs[tab].rowsPerPage = rows;
        },

        UPDATE_SORT_OPTIONS(state, { tab, field, order }) {
            state.tabs[tab].sortField = field;
            state.tabs[tab].sortOrder = order;
        },

        RESET_FIRST_VALUE(state, { tab }) {
            const currentPage = state.tabs[tab].currentPage;
            const rowsPerPage = state.tabs[tab].rowsPerPage;
            state.tabs[tab].first = currentPage > 0 ? (currentPage - 1) * rowsPerPage : 0;
        },

        RESET_CURRENT_PAGE(state, { tab, page = 0 }) {
            state.tabs[tab].currentPage = page;
        },

        UPDATE_SEARCH_TEXT(state, searchText) {
            state.searchText = searchText;
        },

        UPDATE_CURRENT_TAB(state, currentTab) {
            state.currentTab = currentTab;
        },

        SET_LOADING(state, isLoading) {
            state.isLoading = isLoading;
        },

        UPDATE_PRODUCTS_VIEW(state, value) {
            state.productsView = value;
        },

        UPDATE_CLEANED_VIEW(state, value) {
            state.cleanedView = value;
        },
    },

    actions: {
        async fetchTableData({ commit, state, dispatch }) {
            commit("SET_LOADING", true);

            const currentTabState = state.tabs[state.currentTab];
            const params = buildParams(currentTabState, state);
            const apiEndpoint = getApiEndpoint(state.currentTab);
            const queryString = buildQueryString(params);

            try {
                const data = await apiEndpoint(`?${queryString}`);
                commit("SET_TABLE_DATA", { tab: state.currentTab, data });
            } catch (error) {
                commit("SET_TABLE_DATA", { tab: state.currentTab, data: { data: [], count: 0 } });
                console.error("Error fetching data:", error);
            } finally {
                commit("SET_LOADING", false);
                dispatch("resetFirstValue", { tab: state.currentTab });
            }
        },

        updateTableSettings({ commit, dispatch, state }, { rows, page }) {
            commit("UPDATE_ROWS_PER_PAGE", { tab: state.currentTab, rows });
            commit("UPDATE_CURRENT_PAGE", { tab: state.currentTab, page: page + 1 });
            dispatch("fetchTableData");
        },

        updateSortOptions({ commit, dispatch, state }, { field, order }) {
            commit("UPDATE_SORT_OPTIONS", { tab: state.currentTab, field, order });
            dispatch("fetchTableData");
        },

        updateSearchCriteria({ commit, dispatch }, { searchText }) {
            commit("UPDATE_SEARCH_TEXT", searchText);
            dispatch("fetchTableData");
        },

        updateTab({ commit, dispatch }, currentTab) {
            commit("UPDATE_CURRENT_TAB", currentTab);
            dispatch("fetchTableData");
        },

        resetFirstValue({ commit }, { tab }) {
            commit("RESET_FIRST_VALUE", { tab });
        },

        resetCurrentPage({ commit, state }, payload = { tab: state.currentTab, page: 0 }) {
            const tab = payload.tab || state.currentTab;
            const page = typeof payload.page === "number" ? payload.page : 0;
            commit("RESET_CURRENT_PAGE", { tab, page });
        },
    },
};

function buildQueryString(params) {
    return Object.entries(params)
        .filter(([, v]) => v !== undefined && v !== null && v !== "")
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join("&");
}

function buildParams(currentTabState, state) {
    const params = {
        page: currentTabState.currentPage,
        limit: currentTabState.rowsPerPage,
        orderBy: currentTabState.sortField,
        order: currentTabState.sortOrder,
        tab: state.currentTab,
    };

    // Search tab
    if (state.searchText) {
        params.searchTerm = state.searchText;
    }
    // if (state.currentTab === "search" && state.searchText) {
    //     params.searchTerm = state.searchText;
    // }


    if (state.currentTab === "products") {
        if (state.productsView === "deleted") params.isDeleted = true;
        if (state.productsView === "archived") params.isArchived = true;


        if (state.productsView === "moved") params.movedToVerified = true;
    }

    if (state.currentTab === "cleaned") {
        if (state.cleanedView === "deleted") params.isDeleted = true;
        if (state.cleanedView === "archived") params.isArchived = true;
    }

    return params;
}

function getApiEndpoint(tab) {
    switch (tab) {
        case "cleaned":
            return ProductVerifiedService.searchProducts;
        default:
            return ProductServiceV2.searchProducts;
    }
}
